import { locationUpdate } from './action-contact-location';
import { contactByEmail } from './action-contact-option';

export default function fetchContactUsOnLogin() {
  const isLoggedIn = document.body.getAttribute('isloggedin');
  return (dispatch, getState) => {
    const { modal: { fromChannel }, emailForm: { fields }, user: { islocaleChanged } } = getState();
    if (fromChannel === 'callUs' && isLoggedIn && !islocaleChanged) {
      dispatch(locationUpdate({ pageName: 'callUs' }));
    }
    if (fromChannel === 'emailUs' && isLoggedIn && !islocaleChanged) {
      dispatch(contactByEmail(fields));
      dispatch(locationUpdate({ pageName: 'contactUs' }));
    }
    if (fromChannel === 'email' && isLoggedIn && !islocaleChanged) {
      dispatch(locationUpdate({ pageName: 'email' }));
    }
  };
}
